export const initialData = [
  {
    id: "100006759",
    displayDate: "09/03/2026",
    time: "15:20:17",
    senderName: "SparkMinds JSC",
    senderEmail: "uat-moneymatch@yopmail.com",
    receiverName: "checking aml benefi approve",
    paymentMethod: "Cash",
    sendAmount: "2",
    currency: "SGD",
    status: "Waiting admin approval",
    statusValue: "waiting_admin",
    details: {
      customerType: "Organization",
      customerId: "157",
      idType: "Company Registration",
      idNumber: "UEN202012345Z",
      bankTransferAmount: "0 SGD",
      cashAmount: "2",
      receiverType: "Individual",
      receivingMethod: "Cash Pickup",
      bankAgent: "Local Bank",
      country: "Singapore",
      accountNoIban: "SG12BANK39201940",
      address: "123 Marina Bay",
      ifscCode: "--",
      purposeOfTransfer: "Supplier/Vendor/Agent Payment",
      sourceOfFunds: "Corporate Funds",
      receivingAmount: "2 SGD",
      exchangeRate: "1 SGD = 1 SGD",
      serviceCharge: "0.20 SGD",
      promo: "0.00 SGD",
      totalAmount: "2.20 SGD"
    }
  },
  {
    id: "100006551",
    displayDate: "04/03/2026",
    time: "09:42:23",
    senderName: "QC",
    senderEmail: "kieuhanhnguyenn@gmail.com",
    receiverName: "Nguyen Kieu Hanh",
    paymentMethod: "Cash",
    sendAmount: "7.35",
    currency: "SGD",
    status: "Waiting for AML transaction approval",
    statusValue: "waiting_aml",
    details: {
      customerType: "Individual",
      customerId: "481",
      idType: "NRIC (Citizen)",
      idNumber: "811111111999",
      bankTransferAmount: "0 SGD",
      cashAmount: "7.35",
      receiverType: "Organization",
      receivingMethod: "Bank Transfer",
      bankAgent: "ASIA UNITED BANK",
      country: "Philippines",
      accountNoIban: "394589437521",
      address: "2323",
      ifscCode: "--",
      purposeOfTransfer: "Supplier/Vendor/Agent Payment",
      sourceOfFunds: "Salary",
      receivingAmount: "72.9 PHP",
      exchangeRate: "1 SGD = 36.45 PHP",
      serviceCharge: "5.35 SGD",
      promo: "0.00 SGD",
      totalAmount: "7.35 SGD"
    }
  },
  {
    id: "100006542",
    displayDate: "04/03/2026",
    time: "09:25:31",
    senderName: "QUAN PHI VO",
    senderEmail: "quanht@sparkminds.net",
    receiverName: "Kieu Hanh Nguyen",
    paymentMethod: "Cash",
    sendAmount: "2",
    currency: "SGD",
    status: "Processing",
    statusValue: "processing",
    details: {
      customerType: "Individual",
      customerId: "231",
      idType: "Passport",
      idNumber: "E1234567M",
      bankTransferAmount: "0 SGD",
      cashAmount: "2",
      receiverType: "Individual",
      receivingMethod: "Bank Transfer",
      bankAgent: "Vietcombank",
      country: "Vietnam",
      accountNoIban: "018100234123",
      address: "123 Quan 1",
      ifscCode: "--",
      purposeOfTransfer: "Family support",
      sourceOfFunds: "Salary",
      receivingAmount: "36,000 VND",
      exchangeRate: "1 SGD = 18,000 VND",
      serviceCharge: "0.50 SGD",
      promo: "0.00 SGD",
      totalAmount: "2.50 SGD"
    }
  },
  {
    id: "100006465",
    displayDate: "26/02/2026",
    time: "17:45:44",
    senderName: "Coco Nana",
    senderEmail: "coconana@yopmail.com",
    receiverName: "SparkMinds malaysia 02",
    paymentMethod: "Cash",
    sendAmount: "1",
    currency: "SGD",
    status: "Waiting admin approval",
    statusValue: "waiting_admin",
    details: {
      customerType: "Individual",
      customerId: "182",
      idType: "NRIC",
      idNumber: "S1234567A",
      bankTransferAmount: "0 SGD",
      cashAmount: "1",
      receiverType: "Organization",
      receivingMethod: "Bank Transfer",
      bankAgent: "Maybank",
      country: "Malaysia",
      accountNoIban: "12312312312",
      address: "Kuala Lumpur",
      ifscCode: "--",
      purposeOfTransfer: "B2B Payment",
      sourceOfFunds: "Personal savings",
      receivingAmount: "3.5 MYR",
      exchangeRate: "1 SGD = 3.5 MYR",
      serviceCharge: "0.20 SGD",
      promo: "0.00 SGD",
      totalAmount: "1.20 SGD"
    }
  },
  {
    id: "100006464",
    displayDate: "26/02/2026",
    time: "17:02:47",
    senderName: "Others ABC",
    senderEmail: "idtypeisothers@yopmail.com",
    receiverName: "abc org orga001 orga001",
    paymentMethod: "Cash",
    sendAmount: "1",
    currency: "SGD",
    status: "Waiting admin approval",
    statusValue: "waiting_admin",
    details: {
      customerType: "Individual",
      customerId: "991",
      idType: "Others",
      idNumber: "OTH987654",
      bankTransferAmount: "0 SGD",
      cashAmount: "1",
      receiverType: "Organization",
      receivingMethod: "Cash Pickup",
      bankAgent: "Western Union",
      country: "USA",
      accountNoIban: "-",
      address: "New York",
      ifscCode: "--",
      purposeOfTransfer: "Charity",
      sourceOfFunds: "Salary",
      receivingAmount: "0.73 USD",
      exchangeRate: "1 SGD = 0.73 USD",
      serviceCharge: "0.20 SGD",
      promo: "0.10 SGD",
      totalAmount: "1.10 SGD"
    }
  },
  {
    id: "5665",
    displayDate: "18/12/2025",
    time: "09:43:24",
    senderName: "SparkMinds JSC",
    senderEmail: "uat-moneymatch@yopmail.com",
    receiverName: "4 Receivers",
    paymentMethod: "Cash",
    sendAmount: "91",
    currency: "SGD",
    itemCount: "4 item(s)",
    status: "Processing",
    statusValue: "processing",
    details: {
      customerType: "Organization",
      customerId: "157",
      idType: "Company Registration",
      idNumber: "UEN202012345Z",
      bankTransferAmount: "0 SGD",
      cashAmount: "91",
      receiverType: "Multiple",
      receivingMethod: "Bulk Transfer",
      bankAgent: "-",
      country: "Multiple",
      accountNoIban: "-",
      address: "-",
      ifscCode: "-",
      purposeOfTransfer: "Payroll",
      sourceOfFunds: "Corporate Funds",
      receivingAmount: "-",
      exchangeRate: "-",
      serviceCharge: "5.00 SGD",
      promo: "0.00 SGD",
      totalAmount: "96.00 SGD"
    }
  },
  {
    id: "100005334",
    displayDate: "15/12/2025",
    time: "11:24:59",
    senderName: "SparkMinds JSC",
    senderEmail: "uat-moneymatch@yopmail.com",
    receiverName: "Hangzhou",
    paymentMethod: "Cash",
    sendAmount: "3.12",
    currency: "SGD",
    status: "Processing",
    statusValue: "processing",
    details: {
      customerType: "Organization",
      customerId: "157",
      idType: "Company Registration",
      idNumber: "UEN202012345Z",
      bankTransferAmount: "0 SGD",
      cashAmount: "3.12",
      receiverType: "Individual",
      receivingMethod: "Bank Transfer",
      bankAgent: "Bank of China",
      country: "China",
      accountNoIban: "6212260000012345",
      address: "Hangzhou",
      ifscCode: "--",
      purposeOfTransfer: "Supplier/Vendor/Agent Payment",
      sourceOfFunds: "Corporate Funds",
      receivingAmount: "16.50 CNY",
      exchangeRate: "1 SGD = 5.29 CNY",
      serviceCharge: "1.00 SGD",
      promo: "0.00 SGD",
      totalAmount: "4.12 SGD"
    }
  },
  {
    id: "100005322",
    displayDate: "12/12/2025",
    time: "10:38:06",
    senderName: "QC",
    senderEmail: "kieuhanhnguyenn@gmail.com",
    receiverName: "Thị Hạnh Nguyễn Kiều",
    paymentMethod: "Cash",
    sendAmount: "501.2",
    currency: "USD",
    status: "Processing",
    statusValue: "processing",
    details: {
      customerType: "Individual",
      customerId: "481",
      idType: "NRIC (Citizen)",
      idNumber: "811111111999",
      bankTransferAmount: "0 USD",
      cashAmount: "501.2",
      receiverType: "Individual",
      receivingMethod: "Bank Transfer",
      bankAgent: "Vietcombank",
      country: "Vietnam",
      accountNoIban: "018100123456",
      address: "Ho Chi Minh City",
      ifscCode: "--",
      purposeOfTransfer: "Family support",
      sourceOfFunds: "Savings",
      receivingAmount: "12,600,000 VND",
      exchangeRate: "1 USD = 25,140 VND",
      serviceCharge: "5.00 USD",
      promo: "0.00 USD",
      totalAmount: "506.20 USD"
    }
  },
  {
    id: "100005274",
    displayDate: "09/12/2025",
    time: "11:09:24",
    senderName: "Hanh Nguyen Thi Kieu",
    senderEmail: "kieuhanhnguyen.qc@yopmail.com",
    receiverName: "qc",
    paymentMethod: "Cash",
    sendAmount: "24",
    currency: "SGD",
    status: "Processing",
    statusValue: "processing",
    details: {
      customerType: "Individual",
      customerId: "332",
      idType: "NRIC",
      idNumber: "G1234567M",
      bankTransferAmount: "0 SGD",
      cashAmount: "24",
      receiverType: "Individual",
      receivingMethod: "Cash Pickup",
      bankAgent: "Western Union",
      country: "Vietnam",
      accountNoIban: "-",
      address: "Da Nang",
      ifscCode: "--",
      purposeOfTransfer: "Freelancer payment",
      sourceOfFunds: "Salary",
      receivingAmount: "432,000 VND",
      exchangeRate: "1 SGD = 18,000 VND",
      serviceCharge: "3.00 SGD",
      promo: "0.00 SGD",
      totalAmount: "27.00 SGD"
    }
  },
  {
    id: "100005252",
    displayDate: "05/12/2025",
    time: "18:06:19",
    senderName: "SparkMinds JSC",
    senderEmail: "uat-moneymatch@yopmail.com",
    receiverName: "United Kingdom Org",
    paymentMethod: "Cash",
    sendAmount: "2",
    currency: "SGD",
    status: "Processing",
    statusValue: "processing",
    details: {
      customerType: "Organization",
      customerId: "157",
      idType: "Company Registration",
      idNumber: "UEN202012345Z",
      bankTransferAmount: "0 SGD",
      cashAmount: "2",
      receiverType: "Organization",
      receivingMethod: "Bank Transfer",
      bankAgent: "Barclays Bank",
      country: "United Kingdom",
      accountNoIban: "GB12BARC20000012345678",
      address: "London",
      ifscCode: "--",
      purposeOfTransfer: "Subscription fees",
      sourceOfFunds: "Corporate Funds",
      receivingAmount: "1.15 GBP",
      exchangeRate: "1 SGD = 0.58 GBP",
      serviceCharge: "1.00 SGD",
      promo: "0.00 SGD",
      totalAmount: "3.00 SGD"
    }
  },
];
